import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { ConfigProvider } from "antd";
import pt_BR from "antd/lib/locale-provider/pt_BR";
import { ThemeProvider } from "styled-components";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import store from "./store/configureStore";
import App from "./views/App";
import ErrorBoundary from "./views/ErrorBoundary";

import * as amplitude from '@amplitude/analytics-browser';


import { ReactKeycloakProvider } from "@react-keycloak/web"

import "antd/dist/antd.css";
import "nprogress/nprogress.css";
import "./styles/css/pages/layout.css";
import "./styles/css/custom.css";
import theme from "./styles/theme";
import { keycloakClient, keycloakInitConfiguration } from "./keycloak/client";

const RELEASE = process.env.REACT_APP_SENTRY_RELEASE;

if (process.env.NODE_ENV === "production"){

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const emailUsuario  = sessionStorage.getItem('email');
  
    amplitude.init('df053c6691c18d4258751033d5474a27',emailUsuario, {
      fetchRemoteConfig: true,
      autocapture: { elementInteractions: true }
    });
}

if (process.env.NODE_ENV === "production" && RELEASE) {
  
  Sentry.init({
    dsn:
      "https://9608a3b46caf4ab693d5525d1e74ab04@o443341.ingest.sentry.io/5424861",
    release: RELEASE,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  Sentry.configureScope((scope) => {
    scope.setUser({
      email: window.atob(sessionStorage.getItem("Login")),
    });
  });
}

ReactDOM.render(
  <ReactKeycloakProvider
    authClient={keycloakClient}
    initOptions={keycloakInitConfiguration}
    onTokens={({token}) => {
      sessionStorage.setItem("eRecuperadorJwt", token);
    }} 
  >
    <Provider store={store}>
        <ConfigProvider locale={pt_BR}>
          <ThemeProvider theme={theme}>
            <Sentry.ErrorBoundary
              fallback={({ resetError }) => <ErrorBoundary reset={resetError} />}
            >
              <App />
            </Sentry.ErrorBoundary>
          </ThemeProvider>
        </ConfigProvider>
      </Provider>
  </ReactKeycloakProvider>
  ,
  document.getElementById("root")
);
